import React from "react";

const About=()=>{
    return <div className="pages">
        <h1>For better experience,download the Pizza Hub app now</h1>
            <div className="a-imgs">
            <img className="l-i" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJ89jlLpiNDcvESPjnChG9VfymgrvGSyUwiQ&s" alt="e-image"></img>
            <img className="a-i" src="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/play_store.png" alt="e-image"></img>
            <img className="a-i" src="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/app_store.png" alt="e-image"></img>
            </div>
    </div>
}
export default About;